// Log pageview to Google Tag Manager
function logPageView () {
  window.dataLayer.push({ event: 'pageView' })
}

// Log event to Google Tag Manager
function logCustomEvent ({ action, category, label, value }) {
  window.dataLayer.push({
    event: 'customEvent',
    eventAction: action,
    eventCategory: category,
    eventLabel: label,
    eventValue: value
  })
}

export {
  logPageView,
  logCustomEvent
}
